// extracted by mini-css-extract-plugin
module.exports = {"decks":"Decks_decks_26DyR","decks__title":"Decks_decks__title_1x0WP","decks__list":"Decks_decks__list_39zGh"};